import { createStore } from 'vuex'
import axios from 'axios'
import api from '@/api'
import router from '@/router'
import createPersistedState from 'vuex-persistedstate'
const Swal = require('sweetalert2')
const debug = process.env.NODE_ENV !== 'production'

export default createStore({
  state: {
    errorMessage: null,
    lang: 'zh',
    auth: {
      authorized: false,
      user: null,
      userRole: null, // 'prime_english
      group: null
    },
    isLoading: false,
    nodeEnv: process.env.NODE_ENV,
    auth_email: null,
    remainPoints: 0,
    playbackRate: 1,
    isOpenSubtitle: true,
    selectedAccent: 'en-EN' // 'en-EN ', 'it-IT', 'en-GB', 'en-AU'
  },

  getters: {
    authorized:  (state) => state.auth.authorized,
    userRole:  (state) => state.auth.userRole,
    user:  (state) => state.auth.user,
    isLoading:  (state) => state.isLoading,
    lang:  (state) => state.lang,
    remainPoints:  (state) => state.remainPoints,
    isOpenSubtitle:  (state) => state.isOpenSubtitle,
    playbackRate:  (state) => state.playbackRate,
    selectedAccent: state => state.selectedAccent,
    group: state => state.auth.group
  },

  actions: {
    async useTokenLogin({ commit, dispatch }, token) {
      try {
        dispatch('isLoading', true)

        await commit('LOGIN' , '')
        await localStorage.removeItem('prime_english')
        await localStorage.setItem('authorizedAIToken', token)

        dispatch('getRemainPoints')
        dispatch('isLoading', false)
      } catch (err) {
        dispatch('isLoading', false)
        console.error(err)
        Swal.fire({
          html: `<p class="mb-2 whitespace-pre-wrap text-center ">錯誤</p>`,
          showDenyButton: false,
          focusConfirm: false,
          confirmButtonText: '關閉',
          title: '提示',
          customClass: {
            popup: 'p-0 max-w-md w-full',
            header: 'swal-header-notice justify-center items-center',
            htmlContainer: 'my-4',
            actions: 'mb-4 mt-2',
            confirmButton: 'btn-submit ai_bg_01 rounded',
            title: 'text-white text-lg py-4 ai_bg_01'
          }
        })
      }
    },

    async loginWebsite({ commit, dispatch }, user) {
      try {
        dispatch('isLoading', true)
        const path = user.routeName === 'login_prime_english'
          ? 'https://cloud.liveabc.com/api/tp/chenliedu/login'
          : 'https://cloud.liveabc.com/api/tp/LiveABC/login'
        const response = await axios.post(path, {
          email: user.email,
          password: user.password
        })

        if (response) {
          if (user.routeName === 'login_prime_english') {
            commit('LOGIN' , 'prime_english')
            localStorage.setItem('prime_english', true)
          } else {
            commit('LOGIN' , '')
            localStorage.removeItem('prime_english')
          }

          localStorage.setItem('authorizedAIToken', response.data.access_token)
          dispatch('getRemainPoints')
          router.push({ name: 'myList' })
          dispatch('isLoading', false)
        }
      } catch (err) {
        dispatch('isLoading', false)
        console.error(err)
        Swal.fire({
          html: `<p class="mb-2 whitespace-pre-wrap text-center ">${err.response.data.msg}</p>`,
          showDenyButton: false,
          focusConfirm: false,
          confirmButtonText: '關閉',
          title: '提示',
          customClass: {
            popup: 'p-0 max-w-md w-full',
            header: 'swal-header-notice justify-center items-center',
            htmlContainer: 'my-4',
            actions: 'mb-4 mt-2',
            confirmButton: 'btn-submit ai_bg_01 rounded',
            title: 'text-white text-lg py-4 ai_bg_01'
          }
        })
      }
    },
    login_func: async ({ commit, dispatch }, token) => {
      await axios.post(`https://cloud.liveabc.com/api/tp/LiveABC/login`, {
          token: token.token
        })
      .then(response => {
        commit('LOGIN', 'user')
        dispatch('getRemainPoints')
        router.push({ name: 'myList' })
        localStorage.setItem('authorizedAIToken', response.data.access_token)
      })
      .catch(error => {
        console.log(error)
      })
    },
    async loginByGoogle({ commit, dispatch }, token) {
      try {
        // const path = 'https://cloud.liveabc.com/api/login/google'
        const path = 'https://api.liveabc.com/v1/google_login'
        const response = await axios.post(path, {
          token: token
        })

        if (response) {
          // commit('LOGIN', 'user')
          // localStorage.setItem('authorizedAIToken', response.data.access_token)
          // dispatch('getRemainPoints')
          // router.push({ name: 'myList' })
          dispatch('login_func', { token: response.data.access_token })
        }
      } catch (err) {
        Swal.fire({
          html: `<p class="mb-2 whitespace-pre-wrap text-center ">${err.response.data.msg}</p>`,
          showDenyButton: false,
          focusConfirm: false,
          confirmButtonText: '關閉',
          title: '提示',
          customClass: {
            popup: 'p-0 max-w-md w-full',
            header: 'swal-header-notice justify-center items-center',
            htmlContainer: 'my-4',
            actions: 'mb-4 mt-2',
            confirmButton: 'btn-submit ai_bg_01 rounded',
            title: 'text-white text-lg py-4 ai_bg_01'
          }
        })
        router.push({ name: 'register', query: err.response.data.data })
      }
    },

    async getRemainPoints({ commit, dispatch, state }) {
      let path = `https://cloud.liveabc.com/api/tp/LiveABC/points`
      try {
        let response = await api.get(path)
        if (response && response.data) {
          commit('SETUSER', response.data)
          if (state.auth.userRole === 'prime_english' || localStorage.getItem('prime_english')) {
            dispatch('getGroup')
          }
        }
      } catch (err) {
        console.error(err);
      }
    },

    async getGroup({ commit }) {
      let path = `https://cloud.liveabc.com/api/groups`
      try {
        let response = await api.get(path)
        if (response && response.data) {
          commit('SETGROUP', response.data)
        }
      } catch (err) {
        console.error(err);
      }
    },

    async logout({ commit, state }) {
      if (state.auth.userRole === 'prime_english') {
        router.push({ name: 'login_prime_english' })
      } else {
        router.push({ name: 'login' })
      }
      localStorage.removeItem('authorizedAIToken')
      localStorage.removeItem('prime_english')
      commit('LOGOUT')
    },

    async setPlayBackRate({ commit }, data) {
      commit('SETPLAYBACKRATE', data)
    },
    async toggleSubtitle({ commit }, data) {
      commit('TOGGLESUBTITLE', data)
    },
    async isLoading({ commit }, data) {
      commit('ISLOADING', data)
    },
    async register({ dispatch }, user) {
      try {
        await axios.post('https://api.liveabc.com/v1/register?proof=1', {
          name: user.name,
          password: user.password,
          account: user.account,
          code: user.code,
          isAgreeReceiveDM: user.isAgreeReceiveDM
        });

        await dispatch('loginWebsite', { email: user.account, password: user.password })
        router.push({ name: 'myList' });
      } catch (error) {
        // dispatch('updateAlert', { isAlert: true, isHead: true, alertMsg: '驗證碼錯誤或帳號已存在', type: 'alert' })
      }
    },
    setAccent: ({ commit }, data) => {
      commit('SETACCENT', data)
    }
  },

  mutations: {
    ISLOADING (state, data) {
      state.isLoading = data
    },
    SETLANG (state, value) {
      state.lang = value
    },
    LOGIN (state, data) {
      state.auth.authorized = true
      state.auth.userRole = data
    },
    SETUSER (state, data) {
      state.auth.user = data
      state.remainPoints = data.points
    },
    LOGOUT (state) {
      state.auth.authorized = false
      state.auth.userRole = null
      state.remainPoints = 0
      state.auth.user = null
      state.auth.group = null
    },
    SETPLAYBACKRATE (state, value) {
      state.playbackRate = value
    },
    TOGGLESUBTITLE (state, value) {
      state.isOpenSubtitle = value
    },
    SETACCENT (state, value) {
      state.selectedAccent = value
    },
    SETGROUP (state, value) {
      state.auth.group = value
    }
  },

  strict: debug,
  plugins: [createPersistedState({ paths: ['auth'] })]
})
